import React from "react";
import { Link } from "react-router-dom";

class Frequent extends React.Component {
  render() {
    return (
      <div className="col-lg-6">
        <div className="price_box text-center mt-3 p-5">
          <div className="price_name">
            <h1 className="getredtitle">FREQUENT TRAVELER</h1>
          </div>
          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">UNLIMITED GLOBAL WIFI</strong>
            <div style={{ clear: "both" }} />
            <div
              style={{
                width: "40%",
                float: "left",
                display: "inline",
                textAlign: "right"
              }}
            >
              <h1 className="text-custom mb-0 font-weight-normal">$9</h1>
              <p className="text-muted mb-0">PER DAY</p>
            </div>
            <div
              style={{
                width: "20%",
                float: "left",
                display: "inline",
                textAlign: "center"
              }}
            >
              <p className="text-muted mb-0" style={{ paddingTop: "30%" }}>
                OR
              </p>
            </div>
            <div
              style={{
                width: "40%",
                float: "left",
                display: "inline",
                textAlign: "left"
              }}
            >
              <h1 className="text-custom mb-0 font-weight-normal">$99</h1>
              <p className="text-muted mb-0">PER DAY</p>
            </div>
            <div style={{ clear: "both" }} />
          </div>
          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">UNLIMITED GLOBAL WIFI</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">$149.99</h1>
            <p className="text-muted mb-0">OWN THE MIGHTYWIFI</p>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">Connect 10 devices at a time</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">PAY FOR DAYS YOU USE</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">No Sim Card Changes Required</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="plan_price pb-3 mt-4 pt-2">
            <strong className="getmiddle">Secure, Fast, Easy Access</strong>
            <div style={{ clear: "both" }} />
            <h1 className="text-custom mb-0 font-weight-normal">
              <i className="mdi mdi-check" />
            </h1>
          </div>

          <div className="mt-5">
            <a
              href="javascript:void(0)"
              className="btn btn-custom-get-buy w-100"
              style={{ background: "#eee", border: "#eee" }}
            >
              BUY NOW
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Frequent;



// WEBPACK FOOTER //
// ./src/reusable/Frequent.js